<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="600px">
      <custom-modal
        title="Create Bank Account"
        @onSubmit="saveAccount"
        @onClose="show = false"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <ValidationProvider
                v-slot="{ errors }"
                name="Account Number"
                vid="name"
                :bails="false"
                rules="required"
              >
                <v-text-field
                  hide-details="auto"
                  :error-messages="errors"
                  required
                  type="number"
                  v-model="bank.account_number"
                  label="Account Number"
                  auto-grow
                  outlined
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="12" md="6" lg="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Initial amount"
                rules="required"
              >
                <v-text-field
                  hide-details="auto"
                  :error-messages="errors"
                  required
                  type="number"
                  v-model="bank.initial_amount"
                  label="Initial Amount"
                  auto-grow
                  outlined
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" sm="12" md="6" lg="6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Type"
                :bails="false"
                rules="required"
              >
                <v-select
                  hide-details="auto"
                  :items="acoountTypes"
                  v-model="bank.type"
                  item-text="text"
                  item-value="value"
                  label="Type"
                  :error-messages="errors"
                  outlined
                  clearable
                  dense
                  @change="emitInput"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import axios from '@/plugins/axios';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

extend('min', (value) => {
  if (value.length >= 3) {
    return true;
  }
  return 'Please enter above three characters';
});

export default {
  data: () => ({
    show: false,
    bank: {
      account_number: null,
      initial_amount: null,
      type: '',
    },
    shops: [],
    selectedShop: null,
    selectedShop: null,
    searchShop: null,
    loading: false,
    acoountTypes: [
      { text: 'Current Account', value: 'Current Account' },
      { text: 'Saving Account', value: 'Saving Account' },
    ],

    options: [],
    isLoading: false,
  }),

  name: 'BankAccount',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    bankDetails: {
      type: Object,
      default: null,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  watch: {
    // searchShop: {
    //   handler(val) {
    //     this.getShopByQuery(val);
    //   },
    //   deep: true,
    // },
  },
  created() {
    // this.getShopByQuery();
  },
  methods: {
    async saveAccount() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.isLoading = true;
        this.CreateBankAccount();
      }
    },
    openModal() {
      this.show = true;
    },
    // getShopByQuery(query = "") {
    //   this.loading = true;
    //   this.$store
    //     .dispatch("shop/GetShop", {
    //       query: query,
    //       status: "active",
    //     })
    //     .then((res) => {
    //       this.shops = res;
    //       this.loading = false;
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //     });
    // },
    CreateBankAccount() {
      let Credential = this.bank;
      Credential.bank_id = this.bankDetails.id;

      axios
        .post(`bank-account`, Credential)
        .then((res) => {
          this.$toast.success('Bank account created successfully.');
          this.$emit('afterSave');
          this.show = false;
          this.bank = {};
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$refs.observer.setErrors(err.response.data.error);
          this.$toast.error('Failed to create bank account.');
          this.messages = err.data.title;
        });
    },
  },
};
</script>
